<template>
  <el-dialog
    :close-on-click-modal="false"
    title="查看银行回单"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="440px"
  >
    <section>
      <p class="warning" style="margin-bottom: 24px; text-align: center">
        请访问以下网址，并输入对应的单号和验证码即可查看。
      </p>
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      >
        <span slot="url" slot-scope="prop" style="padding-left: 16px">
          <span class="primary cur" @click="copy(prop.form.url)">复制</span>
        </span>
        <span slot="bankPreFlowNumber" slot-scope="prop" style="padding-left: 16px">
          <span class="primary cur" @click="copy(prop.form.bankPreFlowNumber)"
            >复制</span
          >
        </span>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button type="primary" @click="customFormPost" :loading="subLoading"
        >知道了</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '网址',
            value: 'url',
            type: 'input',
            readonly: true,
          },
          {
            label: '电子回单号',
            value: 'bankPreFlowNumber',
            type: 'input',
            readonly: true,
          },
          {
            label: '网址',
            value: 'code',
            type: 'input',
            readonly: true,
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      console.log(item);
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        this.$refs.customForm.setVal(item);
      });
    },

    copy (text) {
      const oInput = document.createElement('input');
      oInput.value = text;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
      });
      oInput.remove();
    },

    customFormPost () {
      this.dialogFormVisible = false;
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.dialogFormVisible = false; // 关闭弹窗
    },
  },
};
</script>

<style>
</style>
